export default [
  '/uic/',
  '/uic/claims/',
  '/uic/customer-service/',
  '/uic/motorcycle/',
  '/uic/partner-with-us/',
  '/uic/why-uic/',
];
